import type { CSSProperties, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface AlertProps {
  /** The stripe colour: `info` (chart blue), `ok`, `warn`, `err` (red). ok and warn also tint the panel. */
  tone: 'info' | 'ok' | 'warn' | 'err'
  title?: ReactNode
  children?: ReactNode
  /** A small button on the right. */
  action?: ReactNode
  className?: string
  style?: CSSProperties
}

/** An inline alert (`.alert.a-*`): a 3px stripe, bold line, muted sentence, optional action. */
export function Alert({ tone, title, children, action, className, style }: AlertProps) {
  return (
    <div
      className={cn('alert', `a-${tone}`, className)}
      style={style}
      role={tone === 'err' ? 'alert' : 'status'}
    >
      <span className="st" />
      <div className="body">
        {title ? <b>{title}</b> : null}
        {children ? <p style={title ? undefined : { margin: 0 }}>{children}</p> : null}
      </div>
      {action}
    </div>
  )
}
